module.exports = __webpack_public_path__ + "static/unterkuenfte_phv-94359b08285e1daf61376babadb23fa0.png";